export default __webpack_public_path__ + "static/media/g3.f0ab008e.jpg";